import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import gachibowli from "./assets/gachibowli_outlet.png";
import jubilee from "./assets/jubliee_outlet.png";
import newOutlet from "./assets/new_outlet.png";
import logo from "./assets/logo.png";
import foodImage from "./assets/food_image.png";
import drinkImage from "./assets/drinks_image.png";
import musicImage from "./assets/music_image.png";
import offerImage from "./assets/food_image.png";
import PrivacyPolicy from "./PrivacyPolicy";

function HomePage() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="App">
      {/* Navbar */}
      <header className="navbar">
        <div className="logo">
          <Link to="/">
            <img src={logo} alt="Airlive Logo" />
          </Link>
        </div>
        <button
          className="menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          ☰
        </button>
        <nav className={menuOpen ? "open" : ""}>
          <Link to="/">Home</Link>
          <a href="#about">About</a>
          <a href="#branches">Branches</a>
          <a href="#services">Services</a>
          <a href="#gallery">Gallery</a>
        </nav>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero">
        <div className="hero-text">
          <img src={logo} alt="Airlive Logo" className="hero-logo" />
          <h1>Welcome to Airlive</h1>
          <p>Hyderabad’s ultimate destination for music, food, and nightlife.</p>
          <img src={offerImage} alt="offer" className="offer-simple" />
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="section about">
        <h2>About Us</h2>
        <div className="about-content">
        <p>
          At Airlive, we bring together the best of music, food, and nightlife
          under one roof. Located in the heart of Hyderabad, Airlive is known
          for its high-energy live performances, premium food and drinks, and
          a stunning rooftop seating experience.
        </p>
        <p>
          Whether you’re here for a casual evening, a night of dancing, or to
          enjoy live bands with friends, Airlive is where unforgettable moments
          are made. With multiple branches across the city, we continue to set
          the benchmark for nightlife experiences.
        </p>

        </div>
      </section>

      {/* Branches Section */}
      <section id="branches" className="section branches">
        <h2>Our Branches</h2>
        <div className="branch-cards">
          <div className="branch-card">
            <img src={gachibowli} alt="Gachibowli Outlet" />
            <h3>Gachibowli</h3>
          </div>
          <div className="branch-card">
            <img src={jubilee} alt="Jubilee Hills Outlet" />
            <h3>Jubilee Hills</h3>
          </div>
          <div className="branch-card">
            <img src={newOutlet} alt="Kondapur" />
            <h3>Kondapur</h3>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="section services">
        <h2>What We Offer</h2>
        <div className="service-cards">
          <div className="service-card">
            <h3>🎶 Live Music</h3>
            <p>
              Enjoy soulful performances and electrifying live bands that make
              every night unforgettable.
            </p>
          </div>
          <div className="service-card">
            <h3>🌌 Rooftop Seating</h3>
            <p>
              Dine and unwind under the stars with a serene and stylish rooftop
              ambiance.
            </p>
          </div>
          <div className="service-card">
            <h3>🍴 Food & Drinks</h3>
            <p>
              Relish world-class cuisines and sip on signature cocktails crafted
              by our expert mixologists.
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="gallery">
        <div className="gallery-simple">
          <div className="top-row">
            <div>
              <img src={foodImage} alt="Food" />
              <h3>Delicious Food</h3>
            </div>
            <div>
              <img src={drinkImage} alt="Drinks" />
              <h3>Refreshing Drinks</h3>
            </div>
          </div>
          <div className="bottom-row">
            <div>
              <img src={musicImage} alt="Live Music" />
              <h3>Live Music</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Line + Contact + Privacy */}
      <div className="footer-line"></div>
      <div className="footer-main">
        <div className="contact-info">
          <h3>Contact Us</h3>
          <p>📍 Address: Road No. 36, Above Jaguar Showroom, Jubilee Hills, Hyderabad, Telangana 500034</p>
          <p>📞 Phone: +91 91606 10002</p>
          <p>📧 Email: gachibowli@theairlive.com</p>
        </div>
        <div className="privacy-link">
          <Link to="/privacy">Privacy Policy</Link>
          <a href="https://merchant.razorpay.com/policy/R6qGXIfobH9BA1/terms" target="_blank" rel="noopener noreferrer" className="razorpay-policy-link">
            Razorpay Policy
          </a>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <p>© {new Date().getFullYear()} Alive. All Rights Reserved to alive.</p>
      </footer>

      {/* Privacy Modal */}
      {showPrivacy && (
        <div className="privacy-modal">
          <div className="privacy-content">
            <button className="close-btn" onClick={() => setShowPrivacy(false)}>
              ✖
            </button>
            <h2>Privacy Policy for Airlive Loyalty App</h2>
            <p><strong>Last Updated: October 12, 2025</strong></p>
            <p>
              Airlive Loyalty ("we," "our," or "us") operates the Airlive Loyalty mobile application ("App"). 
              This Privacy Policy describes how we collect, use, and protect your personal information when 
              you use our App and related services.
            </p>
            <p>
              By using our App, you agree to the collection and use of information in accordance with this Privacy Policy.
            </p>
            <p>⸻</p>
            
            <p><strong>1. Information We Collect</strong></p>
            <p>We collect the following types of information to provide you with a personalized loyalty experience:</p>
            
            <p><strong>Personal Information</strong></p>
            <p>When you register or use our App, we may collect:</p>
            <ul>
              <li>Full Name</li>
              <li>Mobile Number</li>
              <li>Email Address</li>
              <li>Date of Birth</li>
              <li>Anniversary Date</li>
            </ul>
            <p>Providing this information helps us manage your loyalty profile, deliver rewards, and communicate offers.</p>
            
            <p><strong>Usage Information</strong></p>
            <p>We automatically collect certain data when you use our App, such as:</p>
            <ul>
              <li>Device type, model, and operating system</li>
              <li>IP address</li>
              <li>App pages viewed, session duration, and actions taken</li>
              <li>Date and time of usage</li>
            </ul>
            <p>This information helps us improve app performance and user experience.</p>
            <p>⸻</p>
            
            <p><strong>2. How We Use Your Information</strong></p>
            <p>We use the collected data to:</p>
            <ul>
              <li>Provide and maintain the loyalty program</li>
              <li>Send personalized rewards, discounts, and offers</li>
              <li>Communicate updates and service-related notifications</li>
              <li>Improve app functionality and user experience</li>
              <li>Analyze usage for performance and feature improvements</li>
              <li>Respond to user support or feedback requests</li>
            </ul>
            <p>We may also share limited data with our trusted partners or associated outlets to enhance your customer experience.</p>
            <p>⸻</p>
            
            <p><strong>3. Data Sharing and Disclosure</strong></p>
            <p>We do not sell or rent your personal data to any third party.</p>
            <p>Your data may be shared with:</p>
            <ul>
              <li>Service Providers assisting in app operations, hosting, or analytics</li>
              <li>Airlive partner venues or loyalty outlets to facilitate offers or rewards</li>
              <li>Legal authorities, if required to comply with applicable laws</li>
            </ul>
            <p>All third parties are required to maintain the confidentiality and security of your data.</p>
            <p>⸻</p>
            
            <p><strong>4. Data Security</strong></p>
            <p>
              We use reasonable and industry-accepted security measures to protect your personal information 
              from unauthorized access, alteration, or disclosure. However, please note that no digital platform 
              or electronic storage system is 100% secure. We take all possible precautions but cannot guarantee 
              absolute security.
            </p>
            <p>⸻</p>
            
            <p><strong>5. Data Retention</strong></p>
            <p>
              We keep your personal data only for as long as necessary to provide the loyalty services and 
              comply with legal obligations. You may request deletion of your account and data at any time 
              by contacting us.
            </p>
            <p>⸻</p>
            
            <p><strong>6. Your Privacy Rights</strong></p>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Request correction or deletion</li>
              <li>Withdraw consent for promotional communications</li>
            </ul>
            <p>To exercise these rights, please contact us at gachibowli@theairlive.com.</p>
            <p>⸻</p>
            
            <p><strong>7. Children's Privacy</strong></p>
            <p>
              Our App is intended for users aged 13 and above. We do not knowingly collect personal data 
              from children under 13. If you believe your child has provided us with personal data, please 
              contact us to have it removed.
            </p>
            <p>⸻</p>
            
            <p><strong>8. Updates to This Privacy Policy</strong></p>
            <p>
              We may update this Privacy Policy periodically. Updates will be posted on this page with an 
              updated "Last Updated" date. For major changes, we will notify you through the App or via email.
            </p>
            <p>⸻</p>
            
            <p><strong>9. Contact Us</strong></p>
            <p>If you have any questions about this Privacy Policy or how we handle your data, please contact us:</p>
            <ul>
              <li>Email: gachibowli@theairlive.com</li>
              <li>Phone: +91 91606 10002</li>
              <li>Website: https://airlivehyd.com/privacy</li>
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
}

export default App;
